const colors = {
  bgLight: "#fafbfc",
};

export default colors;
